import * as yup from "yup";
import { validationNotEmpty, } from "./defaultValidations";

export default yup.object({
  // dashboardStatus: validationNotEmpty("Status"),
  dashboardName: validationNotEmpty("Dashboard Name"),
  dashboardUrl: validationNotEmpty("Dashboard Url"),
});
